export default {
  jobsWithFeedback() {
    return this.event?.jobs?.filter(job => job.professionalFeedback)
  }
}
